import axios from 'axios';
import { UPLOAD_MEDIA_MANULLY } from './paths';

export const uploadManually = async (data) => {
  const response = await axios.post(UPLOAD_MEDIA_MANULLY, data);
  return response;
};
